<section aria-labelledby="main-title">
  <div class="tela-principal">
      <h3 id="main-title">Renan Fochetto</h3>
      <p class="info-cargos">Web-Development / Front-End Development / UX-UI</p>
      <p class="info-email">
        <a href="mailto:renandfochetto@gmail.com" aria-label="Enviar email para Renan Fochetto">renandfochetto&#64;gmail.com</a>
      </p>
      <p class="info-tel">
        <a href="tel:+5511932303469" aria-label="Ligar para +55 11 9 3230-3469">+55 11 9 3230-3469</a>
      </p>
      <p class="info-estudos">
        <a [routerLink]="['/cursos']" (click)="alternarTela('cursos')" aria-label="Ver cursos de Tecnologia da Informação">+ {{ cursosLabel }}</a>
        <span> | </span>
        <a [routerLink]="['/formacao']" (click)="alternarTela('formacao')" aria-label="Ver formação">{{ formacaoLabel }} +</a>
      </p>
  </div>
  <app-cursos *ngIf="telaAtiva === 'cursos'"  (voltarHome)="voltarHome()"></app-cursos>
  <app-formacao *ngIf="telaAtiva === 'formacao'" (voltarHome)="voltarHome()"></app-formacao>
</section>
